import HttpClient from "./http-client";
import Swal from 'sweetalert2'
import { STUDIO_API_URL, STUDIO_CREATE_SCENE, STUDIO_DELETE_SCENE, STUDIO_ADD_WALL, STUDIO_ADD_URL, STUDIO_RE_ORDER, STUDIO_DELETE, STUDIO_UPDATE_STATUS, STUDIO_UPDATE_SCENE_STATUS, GET_STUDIO_LAYOUTS, GET_STUDIO_APPS, LAYOUTS_SWITCH, STUDIO_EMBED_SHORT_CODE, STUDIO_SECENE_RE_ORDER, DUPLICATE_SCENE, UPDATE_SCENE_DURATION, STUDIO_UPDATE_EMBED_SHORT_CODE, STUDIO_SCENE_CONTENT_ADD_IMAGE, STUDIO_UPDATE_URL, STUDIO_SCENE_CONTENT_UPDATE_IMAGE, WEATHER_LOCATION_SEARCH, EDIT_SCENE, STUDIO_ADD_APP, STUDIO_UPDATE_APP, STUDIO_INTRO_POPUP, USER_NOTIFICATIONS, STUDIO_QUOTES_URL, STUDIO_QUOTES_DATA_URL, GET_WEATHER_CONTENT_INFO, GET_WEATHER_LOCATION_INFO, GET_LEADERBOARD } from './api'
import { GET_USER_STUDIO_WALL, GET_SCENES, ACTIVE_SCENE, UPDATE_LAYOUT, LAYOUTS, STUDIO_APPS, UPDATE_STATUS_KEY, DELETE_SCENE_CONTENT_KEY, STUDIO_DELETE_SCENE_KEY, STUDIO_SAVE_DISPLAY_WALL_KEY, STUDIO_SAVE_LINK_WALL_KEY, STUDIO_SAVE_SHORT_CODE_KEY, STUDIO_CREATE_NEW_SCENE, STUDIO_SCENE_RE_ORDER_KEY, STUDIO_SCENE_DUPLICATE, STUDIO_SCENE_CONTENT_UPDATE_DURATION, STUDIO_GET_SHORT_CODE_DATA_FOR_UPDATE, STUDIO_GET_URL_DATA_FOR_UPDATE, STUDIO_UPDATE_EMBED_SHORT_CODE_KEY, STUDIO_SAVE_IMAGE_KEY, STUDIO_UPDATE_URL_KEY, STUDIO_GET_MEDIA_DATA_FOR_UPDATE, STUDIO_UPDATE_IMAGE_KEY, WALL_ID, UPDATE_EXPANDED_ACCORDION, UPDATE_SCENE_NAME, UPDATE_SCENE_HEIGHT, STUDIO_UPDATE_COUNTER, STUDIO_UPDATE_QRCODE, STUDIO_SAVE_APP, STUDIO_UPDATE_NOTICEBOARD, QUOTE_CATEGORY, STUDIO_UPDATE_MOTIVATIONAL_QUOTES, STUDIO_SAVE_UPDATE_APP, STUDIO_UPDATE_CLOCK, STUDIO_UPDATE_CALENDAR, STUDIO_UPDATE_WEATHER_APP, STUDIO_SCENE_CONTENT_UPDATE_ORDER, LOGIN_INTERCOME_DATA, UPDATE_STUDIO_SCENE_STATUS, PROTECTED_WALL_STATUS, STUDIO_UPDATE_LEADERBOARD_APP, STUDIO_LOADER } from '../reducers/keys'
import store from '../store'
import { SOCKET_CONNECTION } from "../utils";

export const USER_STUDIO_WALL = (userID) => {

    return (dispatch) => {

        dispatch({ type: STUDIO_LOADER, payload: false});
        GET_LAYOUT_FROM_API(dispatch);
        dispatch({
            type: WALL_ID,
            payload: userID,
        });
        new HttpClient()
            .get(`${STUDIO_API_URL}/${userID}`)
            .then((response) => {
                const { scenes, response_code, feedList } = response.data;
                if (response_code == 200) {
                    dispatch({
                        type: GET_SCENES,
                        payload: sceneDraggable(scenes),
                        feedList
                    });
                    dispatch({
                        type: GET_USER_STUDIO_WALL,
                        payload: response.data,
                    });
                    dispatch({
                        type: STUDIO_LOADER,
                        payload: true,
                    });
                    if (response.data && Object.keys(response.data).length > 0) dispatch({
                        type: PROTECTED_WALL_STATUS,
                        payload: response.data.protected,
                    });
                }
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};




export const GET_CATEGORY_QUOTE = () => {

    return (dispatch) => {
        new HttpClient()
            .get(`${STUDIO_QUOTES_URL}`)
            .then((response) => {

                const { responseData, responseCode } = response.data;

                if (responseCode == 200) {

                    dispatch({
                        type: QUOTE_CATEGORY,
                        payload: responseData,
                    });
                }

            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};


export const GET_QUOTES = (name) => {
    return new HttpClient().get(`${STUDIO_QUOTES_DATA_URL}/${name}`)
};


export const getPreviewByWallID = (userID) => {
    return new HttpClient().get(`${STUDIO_API_URL}/${userID}`)
};

export const getUserNotification = () => {
    return new HttpClient().get(`${USER_NOTIFICATIONS}`)
};


export const weatherSearchLocation = (location) => {
    return new HttpClient().get(`${WEATHER_LOCATION_SEARCH}`, {
        params: {
            q: location
        }
    })
};
export const getWeatherForcasteByLocation = (locationID, language, unitType) => {
    return new HttpClient().get(`${GET_WEATHER_CONTENT_INFO}/${locationID}/${language}/${unitType == "17" ? true : false}`)
};
export const getWeatherSpecificByLocation = (locationID) => {
    return new HttpClient().get(`${GET_WEATHER_LOCATION_INFO}/${locationID}`)
};


const GET_LAYOUT_FROM_API = (dispatch) => {  
    new HttpClient()
        .get(`${GET_STUDIO_LAYOUTS}`)
        .then((layoutResponse) => {
            if (layoutResponse.data) {
                dispatch({
                    type: LAYOUTS,
                    payload: LAYOUT_RE_STURCTURED_ZONE_WISE(layoutResponse.data.layouts),
                });

            }
        })
        .catch((error) => {
            console.log("LAYOUT ISSUE", error)
        });
}
export const GET_STUDIO_APPS_FROM_API = () => {
    return new HttpClient().get(`${GET_STUDIO_APPS}`)
}
export const studioApps = (data) => {  
    return (dispatch) => {
        dispatch({
            type: STUDIO_APPS,
            payload: data,
        });
    }
}
const LAYOUT_RE_STURCTURED_ZONE_WISE = (layouts) => {
    let data = [];
    if (layouts && layouts.length) {
        layouts.map((item) => {
            const zones = convertObjectToArrayWithPositionKey(item.partitions);
            item["zones"] = zones;
            item["zone"] = zones.length;
            data.push(item);
        })
    }
    return data;

}
const convertObjectToArrayWithPositionKey = (obj) => {
    let result = Object.keys(obj).map((key) => {
        return { "id": `zone${key}`, "name": obj[key] }
    });
    return result;
};


export const UPDATE_ACTIVE_SCENE = (sceneID) => {
    return (dispatch) => {
        dispatch({
            type: ACTIVE_SCENE,
            payload: sceneID,
        });
    };
};

export const sceneDraggable = (scenes) => {
    let data = [];
    if (scenes && scenes.length > 0) {
        data = scenes.map((item) => {
            return { draggbleID: `dragg_${item.mixContentType}`, ...item, sceneContent: emptySceneReStructured(item.sceneContent, item.partitions) }
        })
    }
    return data;
}
const convertObjectToArray = (obj) => {
    let result = Object.keys(obj).map((key) => obj[key]);
    return result;
};

const emptySceneReStructured = (obj, partitions) => {
    try {
        const getPart = convertObjectToArray(partitions);
        const getSceneContent = convertObjectToArray(obj);
        let data = [];
        if (getPart && getPart.length > 0) {
            getPart.map((item, index) => {
                if (getSceneContent && getSceneContent.length && getSceneContent[index] && Object.keys(getSceneContent[index]).length) data.push(getSceneContent[index])
                else data.push({ "name": item, "data": [] })
            })
        }
        return data;
    }
    catch (ex) {
        return convertObjectToArray(obj);
    }
};

export const layoutUpdate = (updateLayoutID) => {
    const layouts = store.getState().layout.layouts;
    const scenes = store.getState().scene;

    const customClass = {
        confirmButton: 'btn btn-primary m-0 px-4',
        cancelButton: 'btn btn-outline-dark me-2 m-0 px-4',
    }

    return (dispatch) => {
        if (layouts && layouts.length > 0) {
            let data = layouts.filter((item) => item.id == updateLayoutID)
            if (data && data[0] && scenes && scenes.scenes && scenes.scenes[scenes.defaultScene]) {
                if (data[0].zone < Object.keys(scenes.scenes[scenes.defaultScene].partitions).length) {
                    Swal.fire({
                        title: `Changing to ${data[0].name}?`,
                        text: "We will Move your first column content to the Full Screen. If there any content available in second column will be deleted.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Switch",
                        cancelButtonText: "Discard Changes",
                        reverseButtons: true,
                        customClass: customClass
                    }).then((result) => {
                        if (result.value) {
                            dispatch({
                                type: UPDATE_LAYOUT,
                                payload: { updateLayoutID, layouts },
                            });
                        }
                        else if (result.dismiss === "cancel") {

                        }
                    });
                }
                else {
                    dispatch({
                        type: UPDATE_LAYOUT,
                        payload: { updateLayoutID, layouts },
                    });
                }

            }
            else {
                dispatch({
                    type: UPDATE_LAYOUT,
                    payload: { updateLayoutID, layouts },
                });
            }
        }

    }
}

export const switchLayout = (sceneId, layoutId) => {
    new HttpClient()
        .put(`${LAYOUTS_SWITCH}`, { sceneId, layoutId })
        .then((response) => {
        })
        .catch((error) => {
            console.log("ERROR", error, error.response)
        });

}

export const updateDuration = (contentId, duration, sceneID) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_SCENE_CONTENT_UPDATE_DURATION,
            payload: { contentId, duration, sceneID },
        });
    }
}

export const updateDurationRequest = (contentId, duration, callbackScene) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${UPDATE_SCENE_DURATION}`, { contentId, duration })
            .then((response) => {
                callbackScene(1)
            })
           
            .catch((error) => {
                callbackScene(1)
                console.log("ERROR", error, error.response)
            });
    }
}

export const getShortCodeDataForUpdate = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_GET_SHORT_CODE_DATA_FOR_UPDATE,
            payload: item,
        });
        callBack();
    }
}
export const getUrlDataForUpdate = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_GET_URL_DATA_FOR_UPDATE,
            payload: item,
        });
        callBack();
    }
}

export const getMediaDataForUpdate = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_GET_MEDIA_DATA_FOR_UPDATE,
            payload: item,
        });
        callBack();
    }
}



export const saveDisplayWall = (contentMixId, positionID, wall, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .post(`${STUDIO_ADD_WALL}`, { contentMixId, position: positionID, wallUrl: wall.selectedValue, wallName: wall.selectedText })
            .then((response) => {
                dispatch({
                    type: STUDIO_SAVE_DISPLAY_WALL_KEY,
                    payload: response.data,
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });


    };
};
export const addApp = (contentMixId, position, appContent, appName, appId, callBack) => {    
    return (dispatch) => {
        new HttpClient()
            .post(`${STUDIO_ADD_APP}`, { contentMixId, position, appContent, appName, appId })
            .then((response) => {
                dispatch({
                    type: STUDIO_SAVE_APP,
                    payload: response.data,
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};

export const updateApp = (contentMixId, sceneContentId, appContent, appId, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_UPDATE_APP}`, { sceneContentId, appContent, appId })
            .then((response) => {
                dispatch({
                    type: STUDIO_SAVE_UPDATE_APP,
                    payload: { contentMixId, sceneContentId, appContent, appId },
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};

export const saveUrl = (contentMixId, positionID, url, callBack, ifError) => {
    return (dispatch) => {
        new HttpClient()
            .post(`${STUDIO_ADD_URL}`, { contentMixId, position: positionID, url: url })
            .then((response) => {
                dispatch({
                    type: STUDIO_SAVE_LINK_WALL_KEY,
                    payload: response.data,
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
                ifError();
            });
    };
};

export const updateRequestUrl = (contentMixId, contentId, url, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_UPDATE_URL}`, { sceneContentId: contentId, url })
            .then((response) => {
                const { data } = response;
                if (data && data.sceneContent)
                    dispatch({
                        type: STUDIO_UPDATE_URL_KEY,
                        payload: { contentMixId, contentId, url, name: data.sceneContent.name },
                    });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};

export const updateCounter = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_COUNTER,
            payload: item,
        });
        callBack();
    }
}

export const updateQRCode = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_QRCODE,
            payload: item,
        });
        callBack();
    }
}

export const updateNoticeBoard = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_NOTICEBOARD,
            payload: item,
        });
        callBack();
    }
}
export const updateClock = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_CLOCK,
            payload: item,
        });
        callBack();
    }
}
export const updateWeatherAPP = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_WEATHER_APP,
            payload: item,
        });
        callBack();
    }
}
export const updateLeaderBoardAPP = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_LEADERBOARD_APP,
            payload: item,
        });
        callBack();
    }
}
export const updateMotivationalQyotes = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_MOTIVATIONAL_QUOTES,
            payload: item,
        });
        callBack();
    }
}
export const updateCalendar = (item, callBack) => {
    return (dispatch) => {
        dispatch({
            type: STUDIO_UPDATE_CALENDAR,
            payload: item,
        });
        callBack();
    }
}
export const saveShortcode = (contentMixId, position, shortCode, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .post(`${STUDIO_EMBED_SHORT_CODE}`, { contentMixId, position, embedUrl: shortCode })
            .then((response) => {
                dispatch({
                    type: STUDIO_SAVE_SHORT_CODE_KEY,
                    payload: response.data,
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};


export const saveImage = (contentMixId, position, postFile, name, timeInterval, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .post(`${STUDIO_SCENE_CONTENT_ADD_IMAGE}`, { contentMixId, position, postFile, name, timeInterval })
            .then((response) => {
                dispatch({
                    type: STUDIO_SAVE_IMAGE_KEY,
                    payload: response.data,
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};

export const updateRequestImage = (contentMixId, contentId, postFile, previewURL, name, timeInterval, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_SCENE_CONTENT_UPDATE_IMAGE}`, { sceneContentId: contentId, postFile, name, timeInterval })
            .then((response) => {
                dispatch({
                    type: STUDIO_UPDATE_IMAGE_KEY,
                    payload: { contentMixId, contentId, postFile, name, previewURL },
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};

export const updateRequestShortcode = (contentMixId, contentId, shortCode, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_UPDATE_EMBED_SHORT_CODE}`, { contentId, embedUrl: shortCode })
            .then((response) => {
                dispatch({
                    type: STUDIO_UPDATE_EMBED_SHORT_CODE_KEY,
                    payload: { contentMixId, contentId, shortCode },
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};

export const CREATE_SCENE = (newLayoutID, wallId, callBack) => {  
    return (dispatch) => { 
        new HttpClient()
            .post(`${STUDIO_CREATE_SCENE}`, { wallId, selectedLayout: String(newLayoutID) })
            .then((response) => {
                //console.log("CREATE_SCENE", response.data)
                dispatch({
                    type: STUDIO_CREATE_NEW_SCENE,
                    payload: response.data,
                });
                callBack()
            })
            .catch((error) => {
                console.log("ERROR", error, error.response)
            });
    };
};

export const INTRO_POPUP_UPDATE = (wallId) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_INTRO_POPUP}`, { wallId })
            .then((response) => {

            })
            .catch((error) => {
                console.log("ERROR", error, error.response)
            });
    };
};

export const DELETE_SCENE = (sceneID,callbackScene) => {
    return (dispatch) => {
        new HttpClient()
            .delete(`${STUDIO_DELETE_SCENE}`, { data: { sceneId: String(sceneID) } })
            .then((response) => {
                dispatch({
                    type: STUDIO_DELETE_SCENE_KEY,
                    payload: { sceneID },
                })

                callbackScene(sceneID)
            })
            .catch((error) => {
                callbackScene(sceneID)
                console.log("ERROR", error, error.response)
            });
    };
};

export const DELETE_SCENE_CONTENT = (sceneContentId, sceneID, callbackScene) => {
    return (dispatch) => {
        new HttpClient()
            .delete(`${STUDIO_DELETE}`, { data: { sceneContentId: String(sceneContentId) } })
            .then((response) => {
                dispatch({
                    type: DELETE_SCENE_CONTENT_KEY,
                    payload: { sceneContentId, sceneID },
                })

                callbackScene()
             })
            .catch((error) => {
                callbackScene()
                console.log("ERROR", error, error.response)
            });
    };
};


export const RE_ORDER = (reorderedItems) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_RE_ORDER}`, { reorderedItems: reorderedItems })
            .then((response) => {
                dispatch({
                    type: STUDIO_SCENE_CONTENT_UPDATE_ORDER,
                    payload: { reorderedItems },
                })
            })
            .catch((error) => {
                console.log("ERROR", error, error.response)
            });
    };
};
export const sceneReOrder = (reorderedItems) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_SECENE_RE_ORDER}`, { reorderedItems: reorderedItems })
            .then((response) => {
                dispatch({
                    type: STUDIO_SCENE_RE_ORDER_KEY,
                    payload: { reorderedItems },
                })
            })
            .catch((error) => {
                console.log("ERROR", error, error.response)
            });
    };
};

export const UPDATE_STATUS = (status, wallId) => {

    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_UPDATE_STATUS}`, { status, wallId })
            .then((response) => {

                const { data } = response
                
                SOCKET_CONNECTION.emit('wallsuperrefresh', { 'wallId': localStorage.getItem('wallId'), sync: data.synced });

                dispatch({
                    type: UPDATE_STATUS_KEY,
                    payload: status,
                });
            })
            .catch((error) => {
                //API nhi chal rhi hai isliye esa kiya hai isko remove karna hai 
                let statusUpdate = status ? 1 : 0
                dispatch({
                    type: UPDATE_STATUS_KEY,
                    payload: statusUpdate,
                });
                console.log("ERROR", error, error.response)
            });
    };
};


export const UPDATE_SCENE_STATUS = (sceneId, status, callbackScene) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${STUDIO_UPDATE_SCENE_STATUS}`, { sceneId, status })
            .then((response) => {
                dispatch({
                    type: UPDATE_STUDIO_SCENE_STATUS,
                    payload: { sceneId, status }
                });

                callbackScene();
            })
            .catch((error) => {
                callbackScene()
                console.log("ERROR", error, error.response)
            });
    };
};


export const duplicateScene = (sceneId, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .post(`${DUPLICATE_SCENE}`, { sceneId })
            .then((response) => {
                dispatch({
                    type: STUDIO_SCENE_DUPLICATE,
                    payload: response.data,
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error)
            });
    };
};

export const updateExpandedAccordion = (key) => {
    return (dispatch) => {
        dispatch({
            type: UPDATE_EXPANDED_ACCORDION,
            payload: key,
        });
    }
}

export const getVimeoURL = (vimeoURL) => {
    return new HttpClient()
        .get(`https://vimeo.com/api/oembed.json?url=${vimeoURL}`)
}

export const sceneUpdateTitle = (sceneID, title, css, callBack) => {
    return (dispatch) => {
        new HttpClient()
            .put(`${EDIT_SCENE}`, { sceneId: sceneID, name: title, css: css })
            .then((response) => {
                dispatch({
                    type: UPDATE_SCENE_NAME,
                    payload: { sceneID, title },
                });
                callBack();
            })
            .catch((error) => {
                console.log("ERROR", error, error.response)
            });

    }
}
export const sceneUpdateHeight = (cssStyle, position, layouts, mixContentType, sceneID, currentChanges) => {
    return async (dispatch) => {
        const css = await UPDAATE_DYNAMIC_HEIGHT_WIDTH(cssStyle, position, currentChanges)
        new HttpClient()
            .put(`${EDIT_SCENE}`, { sceneId: sceneID, css: css })
            .then((response) => {
                dispatch({
                    type: UPDATE_SCENE_HEIGHT,
                    payload: { css, sceneID },
                });
            })
            .catch((error) => {
                console.log("ERROR", error, error.response)
            });

    }
}


const UPDAATE_DYNAMIC_HEIGHT_WIDTH = async (cssStyle, position, currentChanges) => {
    const cData = cssStyle.split("#zone");
    let increaseDecrease = null;
    let valueChange = 0;
    let previewValue = 0;
    if (currentChanges && currentChanges.value && currentChanges.label == "Width") {
        if (parseInt(currentChanges.value) < parseInt(currentChanges.width)) {
            increaseDecrease = 2;
            valueChange = parseInt(currentChanges.width) - parseInt(currentChanges.value);
            previewValue = parseInt(currentChanges.width);
        }
        else if (parseInt(currentChanges.value) > parseInt(currentChanges.width)) {
            increaseDecrease = 1;
            valueChange = parseInt(currentChanges.value) - parseInt(currentChanges.width);
            previewValue = parseInt(currentChanges.width);
        }

    }
    else if (currentChanges && currentChanges.value && currentChanges.label == "Height") {
        if (parseInt(currentChanges.value) < parseInt(currentChanges.height)) {
            increaseDecrease = 2;
            valueChange = parseInt(currentChanges.height) - parseInt(currentChanges.value);
            previewValue = parseInt(currentChanges.height);
        }
        else if (parseInt(currentChanges.value) > parseInt(currentChanges.height)) {
            increaseDecrease = 1;
            valueChange = parseInt(currentChanges.value) - parseInt(currentChanges.height);
            previewValue = parseInt(currentChanges.height);
        }
    }
    //console.log("currentChanges", increaseDecrease, valueChange, previewValue, currentChanges)
    var height = ""; var width = "";
    let dataChange = "";
    if (cData && cData.length) {
        await cData.map(async (item, index) => {
            let trimContent = item.trim()
            let firstValue = trimContent.charAt(0);


            if (firstValue == position[0].position) {
                let previewData = `${currentChanges.label.toLowerCase()}:${previewValue}`;
                let latestData = `${currentChanges.label.toLowerCase()}:${parseInt(currentChanges.value)}`
                let reaplceData = `#zone${trimContent.replace(previewData, latestData)}`

                if (currentChanges && currentChanges.value && currentChanges.label == "Height") {
                    if (firstValue == 2) {
                        let splitZone = trimContent.split("{")
                        let splitZone2 = splitZone[1].split(";")
                        let prvtopValue = null;

                        for (let index = 0; index < splitZone2.length; index++) {
                            let splitZone3 = splitZone2[index].split(":");
                            if (splitZone3[0] == "top") {
                                prvtopValue = splitZone3[1]
                            }
                        }
                        let topData1 = `top:${parseInt(prvtopValue)}`;

                        let changesTopData1 = `top:${parseInt(100 - currentChanges.value)}`;
                        reaplceData = reaplceData.replace(topData1, changesTopData1);

                    }
                }

                if (currentChanges && currentChanges.value && currentChanges.label == "Width") {

                    if (firstValue == 2) {
                        let splitZone = trimContent.split("{")
                        let splitZone2 = splitZone[1].split(";")

                        let prvtopValue = null;

                        for (let index = 0; index < splitZone2.length; index++) {
                            let splitZone3 = splitZone2[index].split(":");
                            if (splitZone3[0] == "left") {
                                prvtopValue = splitZone3[1]
                            }
                        }
                        let leftData1 = `left:${parseInt(prvtopValue)}`;

                        let changesLeftData1 = `left:${parseInt(100 - currentChanges.value)}`;

                        reaplceData = reaplceData.replace(leftData1, changesLeftData1);

                    }

                }

                dataChange += reaplceData;


            }
            else {
                let otherZone = await returnHeightWidth(item, currentChanges.label.toLowerCase());
                if (otherZone.height && currentChanges.label.toLowerCase() == "height") {
                    let preVHeightValue = parseInt(otherZone.height)
                    //console.log("item", item, preVHeightValue, increaseDecrease)
                    if (increaseDecrease == 1) {
                        preVHeightValue = parseInt(preVHeightValue) - parseInt(valueChange)
                    }
                    else if (increaseDecrease == 2) {
                        preVHeightValue = parseInt(preVHeightValue) + parseInt(valueChange)
                    }
                    //console.log("item2", item, preVHeightValue, increaseDecrease)
                    let previewData1 = `${currentChanges.label.toLowerCase()}:${otherZone.height}`;
                    let latestData1 = `${currentChanges.label.toLowerCase()}:${parseInt(preVHeightValue)}`

                    let topData = `top:${otherZone.top}`;
                    let changesTopData = `top:${parseInt(currentChanges.value)}`;
                    let reaplceData1 = `#zone${trimContent.replace(previewData1, latestData1)}`
                    reaplceData1 = reaplceData1.replace(topData, changesTopData);
                    dataChange += reaplceData1;


                }
                else if (otherZone.width && currentChanges.label.toLowerCase() == "width") {
                    let preVHeightValue = parseInt(otherZone.width)
                    if (increaseDecrease == 1) {
                        preVHeightValue = parseInt(preVHeightValue) - parseInt(valueChange)
                    }
                    else if (increaseDecrease == 2) {
                        preVHeightValue = parseInt(preVHeightValue) + parseInt(valueChange)
                    }

                    let previewData2 = `${currentChanges.label.toLowerCase()}:${otherZone.width}`;
                    let latestData2 = `${currentChanges.label.toLowerCase()}:${parseInt(preVHeightValue)}`

                    let leftData = `left:${otherZone.left}`;
                    let changesLeftData = `left:${parseInt(currentChanges.value)}`;

                    let reaplceData2 = `#zone${trimContent.replace(previewData2, latestData2)}`
                    reaplceData2 = reaplceData2.replace(leftData, changesLeftData);
                    dataChange += reaplceData2;
                }


            }

        })
        return dataChange;
    }
    return dataChange;
}

const returnHeightWidth = (item, label) => {
    var height = ""; var width = ""; var left = ""; var top = "";
    const trimContent = item.trim()
    const replaceValue = item.split(";")
    if (replaceValue && replaceValue.length) {
        replaceValue.map((rItem) => {
            const getHeightWidth = rItem.split(":");
            if (getHeightWidth && getHeightWidth[0] && getHeightWidth[0] == "height" && label == "height") height = getHeightWidth[1].replace("%", "");
            if (getHeightWidth && getHeightWidth[0] && getHeightWidth[0] == "top") top = getHeightWidth[1].replace("%", "");
            if (getHeightWidth && getHeightWidth[0] && getHeightWidth[0] == "left") left = getHeightWidth[1].replace("%", "");
            if (getHeightWidth && getHeightWidth[0] && getHeightWidth[0] == "width" && label == "width") width = getHeightWidth[1].replace("%", "");
        })
    }
    return { height, width, left, top }
}


export const getLeaderboard = (data) => {
    const { leader, rows, startDate, endDate, feedLists } = data
    var queryFeedList = []
    if (feedLists && feedLists.length > 0) {
        feedLists.map((item) => queryFeedList.push(item.id))
    }
    return new HttpClient().get(`${GET_LEADERBOARD}/${localStorage.getItem('wallId')}/${queryFeedList.join()}?leader=${leader}&rows=${rows}&startDate=${startDate}&endDate=${endDate}`)

}